import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { newsData } from '../data/content';

const News = () => {
  return (
    <div className="pt-24 pb-20 bg-white min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-slate-800 mb-4">最新消息</h1>
          <div className="w-16 h-1 bg-blue-500 mx-auto rounded-full"></div>
        </div>

        <div className="space-y-8">
          {newsData.map((item, index) => (
            <motion.article
              key={item.id}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="bg-slate-50 rounded-2xl p-6 md:p-8 border border-slate-100 hover:shadow-md transition-shadow group"
            >
              <div className="flex items-center text-blue-600 mb-3">
                <SafeIcon name="Calendar" className="mr-2" />
                <time className="text-sm font-medium tracking-wider">{item.date}</time>
              </div>
              <h2 className="text-2xl font-bold text-slate-800 mb-4 group-hover:text-blue-600 transition-colors">
                {item.title}
              </h2>
              <p className="text-slate-600 leading-relaxed">
                {item.content}
              </p>
              
              {item.title.includes('LINE-ID') && (
                <div className="mt-4 p-4 bg-green-50 border border-green-100 rounded-lg flex items-center">
                  <SafeIcon name="MessageCircle" className="text-green-600 mr-3 text-xl" />
                  <span className="text-green-800 font-medium">主要 LINE ID: 0910071850</span>
                </div>
              )}
            </motion.article>
          ))}
        </div>

      </div>
    </div>
  );
};

export default News;